export default __webpack_public_path__ + "static/media/3.90a05324.png";